import { Grid, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import GavelIcon from '@mui/icons-material/Gavel';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import HistoryEduOutlinedIcon from '@mui/icons-material/HistoryEduOutlined';
import React, { useState } from 'react';
import { MandateGeneralDto } from '../../../services/dtos/mandate-general.dto';
import { MandateEstablishmentDto } from '../../../services/dtos/mandate-establishment-dto';
import { MandateTerritoryDto } from '../../../services/dtos/mandate-territory.dto';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import CustomCard from '../../commun/custom-card';
import { FinanceType } from '../../../services/dtos/finances.dto';
import FinanceFileUi from './finance-file.ui';
import { RelationType } from '../../../services/dtos/relation.dto';
import './finances.ui.scss';

type FinanceCategory = {
    icon: React.ReactElement;
    text: string;
    type: FinanceType;
};

const getFinanceCategories = (little: boolean): FinanceCategory[] => [
    {
        text: 'Tableau de bord budgétaire',
        icon: <CalendarMonthIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: FinanceType.BASHBOARD,
    },
    {
        text: 'Admissions en non-valeur',
        icon: <HistoryEduOutlinedIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: FinanceType.ADMISSION,
    },
    {
        text: 'Créances éteintes',
        icon: <GavelIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: FinanceType.DEBT,
    },
    {
        text: 'Liste des impayés',
        icon: <DescriptionOutlinedIcon sx={little ? { fontSize: '5em' } : { fontSize: '9em' }} />,
        type: FinanceType.UNPAID,
    },
];

/**
 * Ui pour les finances
 * @constructor
 */
export default function FinancesUi(
    props: Readonly<{
        mandate?: MandateGeneralDto | MandateEstablishmentDto | MandateTerritoryDto;
    }>
) {
    // title
    const [title, setTitle] = useState<string>();
    // finance
    const [type, setType] = useState<FinanceType | RelationType>();
    // little
    const [little, setLittle] = useState<boolean>(false);

    /**
     * Mise à jour
     * @param newType
     * @param text
     */
    const handlerSetType = (newType: FinanceType | RelationType | undefined, text: string | undefined) => {
        setTitle(text);
        setType(newType);
        setLittle(newType !== undefined);
    };
    const categories = getFinanceCategories(little);

    //Retourne la vue
    return (
        // Premier container finance
        <Grid container className={'financeUi finances-content'} rowSpacing={1}>
            <Grid item xs={12} md={little ? 6 : 12} className="financeUi__header">
                <Typography variant="h3" className={'financeUi__title title'}>
                    <LocalAtmIcon /> Finances
                </Typography>
                {title && (
                    <Typography variant="h4" className={'financeUi__subtitle title'}>
                        {title}
                    </Typography>
                )}
            </Grid>
            {/* Mise en place menu onglet des finances */}
            <Grid item md={little ? 6 : 12} xs={12} className="financeUi__nav">
                {/* Premniere carte */}
                <Grid container className="financeUi__categories" spacing={2} columns={little ? 8 : 12}>
                    {categories.map(category => (
                        <Grid
                            key={category.type}
                            item
                            xs={little ? 4 : 12}
                            sm={little ? 2 : 6}
                            md={little ? 2 : 4}
                            lg={little ? 2 : 3}
                            className="financeUi__categoryItem"
                        >
                            <CustomCard
                                little={little}
                                text={category.text}
                                icon={category.icon}
                                type={category.type}
                                handlerSetType={handlerSetType}
                                isSelected={type === category.type}
                                className="financeUi__categoryCard"
                            />
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            {type !== undefined && (
                <Grid item xs={12}>
                    <FinanceFileUi mandate={props.mandate} type={type} handlerSetType={handlerSetType} />
                </Grid>
            )}
        </Grid>
    );
}
